import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

import SiderForwardButton from '../Utils/SiderForwardButton';
import Card from '../Card';

interface IProps {
    carouselList: IArticle[];
    className?: string;
    hasCard?: boolean;
    isFromArticle?: boolean;
}

const CarouselCard: React.FC<IProps> = ({
    carouselList, className, hasCard, isFromArticle
}): JSX.Element => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [previousIndex, setPreviousIndex] = useState(0);
    const [isFirstRender, setIsFirstRender] = useState(true);

    const carouselListLength = carouselList.length;

    const onNext = (i?: number | undefined) => {
        setIsFirstRender(false);
        setPreviousIndex(activeIndex);
        if (i === undefined) {
            if (activeIndex === carouselListLength - 1) {
                setActiveIndex(0);
            } else {
                setActiveIndex(activeIndex + 1);
            }
        } else {
            setActiveIndex(i);
        }
    };

    const onPrev = (i?: number | undefined) => {
        setIsFirstRender(false);
        setPreviousIndex(activeIndex);
        if (i === undefined) {
            if (activeIndex === 0) {
                setActiveIndex(carouselListLength - 1);
            } else {
                setActiveIndex(activeIndex - 1);
            }
        } else {
            setActiveIndex(i);
        }
    };

    const cardClass = (idx: number) => {
        const classes = classnames(
            {
                [styles.withBackground]: activeIndex === idx,
                [styles.active]: activeIndex === idx && !isFirstRender,
                [styles.activeWithoutAnimation]: idx === 0 && isFirstRender,
                [styles.hide]: activeIndex !== idx && !isFirstRender && idx === previousIndex,
                [styles.hideWithoutAnimation]:
                    (isFirstRender && activeIndex !== idx)
                    || (!isFirstRender && idx !== previousIndex && idx !== activeIndex),
            },
            styles.slider
        );
        return classes;
    };

    function renderCard(i:IArticle, idx:number) {
        return (
            <>
                <div className={styles.imageContainer}>
                    <div className={styles.imageContainer2}>
                        <img
                            src={isFromArticle ? `${process.env.REACT_APP_API_ENDPOINT}${i}` : `${process.env.REACT_APP_API_ENDPOINT}${i.imageURL}`}
                            alt=""
                        />
                    </div>
                </div>
                {hasCard && (
                    <Card
                        classname={classnames({ [styles.visible]: activeIndex === idx }, styles.card)}
                        category={i.relatedMainCategory?.name}
                        title={i.title}
                        tags={i.relatedKeywords}
                    />
                )}
            </>
        );
    }

    function renderCarousel(i:IArticle, idx:number) {
        if (isFromArticle) {
            return (
                <div className={cardClass(idx)} key={`carousel-${i}`}>
                    {renderCard(i, idx)}
                </div>
            );
        }
        return (
            <a
                className={cardClass(idx)}
                href={`/${i.relatedMainCategory?.url}/${i.id}`}
                key={`carousel-${i.id}`}
                title={`移至文章-${i.title}`}
            >
                {renderCard(i, idx)}
            </a>
        );
    }

    return (
        <div className={classnames(className, styles.carousel,
            { [styles.isFromArticle]: isFromArticle, [styles.isNotFromArticle]: !isFromArticle })}
        >
            <div className={styles.dots}>
                {carouselList.map((d, index) => (
                    <button
                        className={classnames({ [styles.active]: index === activeIndex }, styles.dot)}
                        onClick={() => {
                            onNext(index);
                        }}
                        aria-hidden="true"
                        key={`dot-${isFromArticle ? d : d.id}`}
                        type="button"
                        title={`切換至第${index + 1}則編輯精選`}
                    />
                ))}
            </div>
            <div className={classnames(styles.cardContainer)}>
                {carouselList.map((i, idx) => renderCarousel(i, idx))}
                {isFromArticle && carouselList.length > 1
                && (
                    <SiderForwardButton
                        className={styles.backwardButton}
                        handelClick={onPrev}
                        title="切換下則編輯精選"
                    />
                )}
                { carouselList.length > 1
                && (
                    <SiderForwardButton
                        className={styles.forwardButton}
                        handelClick={onNext}
                        title="切換下則編輯精選"
                    />
                )}
            </div>
        </div>
    );
};

CarouselCard.defaultProps = {
    className: '',
    hasCard: false,
    isFromArticle: false,
};

export default CarouselCard;
